exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input:disabled, textarea:disabled{\r\n    color:black !important;\r\n}\r\n\r\n/*\r\n.userInputClass .ui-state-disabled, .ui-widget:disabled{\r\n    opacity: 0.80 !important;\r\n}*/\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/src/app/component/user_dlg.component.css
// module id = ../../../../../src/app/component/user_dlg.component.css
// module chunks = 1